var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icon/Filled/location-marker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23764 5.5521C9.91387 2.87586 14.2529 2.87586 16.9291 5.5521C19.6054 8.22833 19.6054 12.5674 16.9291 15.2436L12.0834 20.0893L7.23764 15.2436C4.56141 12.5674 4.56141 8.22833 7.23764 5.5521ZM12.0834 12.3558C13.1647 12.3558 14.0414 11.4792 14.0414 10.3978C14.0414 9.31648 13.1647 8.43986 12.0834 8.43986C11.002 8.43986 10.1254 9.31648 10.1254 10.3978C10.1254 11.4792 11.002 12.3558 12.0834 12.3558Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a592f53e10731f9555633ae2c219e01b.svg";
export { ForwardRef as ReactComponent };